export interface UpdateReserveSetReserveRequest {
  userId: string
  reserveSetId: number
  reserves: {
    id: number
    bibliographyRealId: number
    reserveSetRank: number
    revision: number
  }[]
}

export function UpdateReserveSetReserveRequestToJSON(
  value: UpdateReserveSetReserveRequest
): any {
  return {
    user_id: value.userId !== '' ? value.userId : undefined,
    reserve_set_id: value.reserveSetId !== 0 ? value.reserveSetId : undefined,
    reserves:
      value.reserves.length > 0
        ? value.reserves.map(reserve => {
            return {
              id: reserve.id !== 0 ? reserve.id : undefined,
              bibliography_real_id:
                reserve.bibliographyRealId !== 0
                  ? reserve.bibliographyRealId
                  : undefined,
              reserve_set_rank:
                reserve.reserveSetRank !== 0
                  ? reserve.reserveSetRank
                  : undefined,
              revision: reserve.revision !== 0 ? reserve.revision : undefined
            }
          })
        : []
  }
}
